import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ViewUI from "view-design";
import 'view-design/dist/styles/iview.css';
import "@/assets/_scroll-bar.less";
import VueMeta from 'vue-meta';


Vue.use(VueMeta);
Vue.use(ViewUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
